import React from 'react';
import Layout from '../components/Layout';

const TermsOfUsePage = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-900 via-secondary-900 to-dark-950 py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl font-display font-bold bg-gradient-to-r from-white via-primary-200 to-accent-300 bg-clip-text text-transparent mb-6">
            Terms of Use
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </div>

      {/* Terms Content */}
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 dark:from-dark-950 dark:to-dark-900 py-16">
        <div className="container mx-auto px-4">
          <div className="space-y-8">
            {[
              {
                title: "Introduction",
                content: `Welcome to MVPsec.ai. By accessing our website and using our services, you agree to be bound by these Terms of Use ("Terms"). These Terms govern your access to and use of the services and products offered by MVPsec.ai ("we", "us", or "our"). If you do not agree with any part of these Terms, you must not use our website or services.`
              },
              {
                title: "Use of Services",
                content: `You agree to use our services only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of MVPsec.ai. Prohibited behavior includes harassing or causing distress or inconvenience to any person, transmitting obscene or offensive content, or disrupting the normal flow of dialogue within our website.`
              },
              {
                  title: "Intellectual Property Rights",
                  content: `The content, layout, design, data, databases, and graphics on this website are protected by UK and international copyright laws. Unless expressly authorized by us, you are not allowed to copy, modify, reproduce, republish, upload, post, transmit, or distribute any documents or information from MVPsec.ai in any form or by any means.`
              },
              {
                  title: "User-Generated Content",
                  content: `You grant us a non-exclusive, transferable, sub-licensable, royalty-free, perpetual, and worldwide license to use any content you post on MVPsec.ai, including ideas, concepts, know-how, or techniques contained in such content, for any purpose.`
              },
              {
                  title: "Disclaimer of Warranties",
                  content: `Our services are provided "as is" without warranty of any kind, either express or implied. We do not guarantee that the services will be uninterrupted or error-free.`
              },
              {
                  title: "Limitation of Liability",
                  content: `MVPsec.ai will not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages, including but not limited to damages for loss of profits, goodwill, use, data, or other intangible losses resulting from the use of or inability to use the service.`
              },
              {
                  title: "Changes to Terms",
                  content: `We reserve the right, at our sole discretion, to modify or replace these Terms at any time. Your continued use of our services following the posting of any changes to these Terms constitutes acceptance of those changes.`

              },
              {
                  title: "Governing Law",
                  content: `These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which MVPsec.ai operates, without giving effect to any principles of conflicts of law.`

              },
              {
                  title: "Contact Us",
                  content: `If you have any questions about these Terms, please contact us at [insert contact information].`
              }
            ].map((section, index) => (
              <div key={index} className="bg-white dark:bg-dark-800 p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100 dark:border-gray-800 hover:border-primary-200 dark:hover:border-primary-800 transform hover:scale-105">
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">
                    {section.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    {section.content}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p className="text-gray-600 dark:text-gray-400">
              If you have any questions about these Terms, please{' '}
              <a href="/contact" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors font-medium">
                contact us
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsOfUsePage;



          